import { StyleSheet, Text, View, Modal, Pressable } from "react-native";
import React, { useState } from "react";
import { scale } from "@utils/scale";
import { colors } from "@constants/theme";

const SalesInfoCard = ({ children, ...props }) => {
  return (
    <>
      {props.visible && (
        <View style={[styles.innerContainer, { ...props.style }]}>
          <View
            style={[styles.triangle, props.left ? { left: 15 } : { right: 15 }]}
          />
          {children}
        </View>
      )}
    </>
  );
};

export default SalesInfoCard;

const styles = StyleSheet.create({
  innerContainer: {
    height: scale(96),
    width: scale(180),
    backgroundColor: colors.white,
    position: "absolute",
    top: 38,
    borderRadius: 8,
    elevation: 8,
    paddingVertical: 12,
    paddingHorizontal: 10,
  },
  triangle: {
    height: 20,
    width: 20,
    backgroundColor: colors.white,
    position: "absolute",
    transform: [{ rotate: "45deg" }],
    top: -7,
  },
});
